import { useStore } from '@nanostores/react';
import { PricingIntervalSelector } from './IntervalSelector';
import { PaymentRenewalBanner } from './PaymentRenewalBanner';
import { PendingUpdateBanner } from './PendingUpdateBanner';
import { WorkspaceSelector } from './WorkspaceSelector';
import { DowngradeConfirmationModal } from '~/components/dialogs/DowngradeConfirmationModal.client';
import { useTokenStats } from '~/lib/hooks/useTokenStats';
import type { PricingWorkspace } from '~/lib/stores/pricing/types';
import { workspacesStore } from '~/lib/stores/pricing/workspaces';
import { classNames } from '~/utils/classNames';
import { SELECTED_ACCOUNT_USER } from '~/utils/constants';

export const PricingHeader = () => {
  const shouldDisplayWorkspaceSelector = useStore(workspacesStore.shouldDisplayWorkspaceSelector);

  const { fetchTokenStats } = useTokenStats();

  const fetchTokenForWorkspace = (workspace: PricingWorkspace) => {
    if (workspace.type === 'personal') {
      fetchTokenStats(SELECTED_ACCOUNT_USER);
    } else if (workspace.type === 'team') {
      fetchTokenStats(workspace.org);
    }
  };

  return (
    <>
      <div className="flex flex-col gap-3 py-4">
        <h1 className="text-center text-4xl font-semibold text-bolt-ds-textPrimary">Pricing</h1>
        <p className="text-center max-w-[600px] w-[90%] mx-auto text-bolt-elements-textSecondary text-lg">
          Start for free. Upgrade as you go.
        </p>
      </div>

      <DowngradeConfirmationModal />

      <PendingUpdateBanner />

      <PaymentRenewalBanner />

      <div
        className={classNames(
          shouldDisplayWorkspaceSelector
            ? 'flex flex-col md:flex-row md:justify-between gap-4 items-center md:h-11'
            : '',
        )}
      >
        {shouldDisplayWorkspaceSelector && (
          <div className="grow-1">
            <WorkspaceSelector onSelectWorkspace={fetchTokenForWorkspace} />
          </div>
        )}

        <PricingIntervalSelector
          className={
            shouldDisplayWorkspaceSelector
              ? 'md:items-end lg:items-center flex-col items-center lg:flex-row-reverse grow-1 lg:basis-60 justify-start'
              : 'flex-col items-center'
          }
        />
      </div>
    </>
  );
};
